import React from "react";
import FaCheckCircle from 'react-icons/lib/fa/check-circle';

const valid = {
    color:'#78BE20'
};
const invalid = {
    color:'#9A9EA6'
};

// const checkStyles= {
//     verticalAlign: "top"
// };

const labelStyles = {
    paddingRight: '10px'
};

const spanStyles = {
    padding: '0 10px',
    fontSize:'10pt'
};
const Requirement = ({ htmlFor, isvalid, message }) => (
    <label htmlFor={htmlFor} className={!isvalid ? `invalid` : `valid`}  style={labelStyles}>
        <FaCheckCircle style={!isvalid ? invalid : valid} />
        <span style={spanStyles}>{message}</span>
    </label>
);

export default Requirement;



// WEBPACK FOOTER //
// ./src/components/PasswordRequirements/Requirement.js